import {computed, signal, WritableSignal} from '@angular/core';
import {StorageService} from "@cybfed/core/services/storage.service";

export class UserStore {
    private _currentUser: WritableSignal<any>  = signal(StorageService.getJsonItem(StorageService.statics.currentUser));
    private _profileData: WritableSignal<any>  = signal(StorageService.getJsonItem(StorageService.statics.profileData));
    private _definedUser: WritableSignal<boolean>  = signal<boolean>(false);
    private _token: WritableSignal<any>  = signal(StorageService.getJsonItem(StorageService.statics.token));

    constructor() {
        if (this._currentUser()) {
            this._definedUser.set(true)
        }
    }

    public definedUserData = computed(() =>
       this._definedUser()
    );

    set currentUser(user: any) {
        this._currentUser.set(user);
        this._definedUser.set(true)
    }

    get currentUser(): any {
        return this._currentUser();
    }

    get profileData(): any  {
        return this._profileData();
    }

    set profileData(data) {
        this._profileData.set(data);
    }

    set token(token: string) {
        this._token.set(token);
    }

    get token(): string {
        return this._token();
    }
}
